import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Layout } from 'antd';
import { makeStyles } from '@material-ui/styles';
import { useDispatch, useSelector } from 'react-redux';
import Information from './Information';
import Security from './Security';
import Corporate from './Corporate';
import InnerHeader from '../../component/InnerHeader';
import CButton from '../../component/Button';
import {
  fetchAccount,
  setPasswordAccount,
  updateAccount,
  updateAccountPassword
} from '../../actions/accountAction';

const useStyles = makeStyles({
  accHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '18px',
    marginLeft: '24px',
    marginRight: '20px'
  },
  layout: {
    alignItems: 'center',
    backgroundColor: '#F0F4FF',
    borderRadius: '12px',
    display: 'flex',
    height: 'calc(100vh - 235px)',
    marginLeft: '24px',
    marginRight: '20px'
  },
  main: {
    height: 'fit-content',
    marginBottom: '100px',
    minHeight: 'calc(100vh - 165px)'
  }
});

const buttonClicked = {
  backgroundColor: '#F0F4FF',
  border: 'none',
  borderRadius: '12px',
  color: '#5564F8',
  fontSize: '13px',
  height: '45px',
  margin: '0 2px'
};

const buttonNotClicked = {
  border: 'none',
  boxShadow: 'none',
  color: '#999',
  fontSize: '13px',
  height: '45px',
  margin: '0 2px'
};

const mainDiv = {
  height: 'calc(100vh - 165px)',
  overflowY: 'scroll'
};

const PageBody = ({ actions }) => {
  const [index, setIndex] = useState(0);
  const [submit, setSubmit] = useState(false);
  const [error, setError] = useState(false);

  const [passMatch, setPassMatch] = useState(false);
  const [passShort, setPassShort] = useState(false);
  const [passError, setPassError] = useState(false);

  const classes = useStyles();
  const dispatch = useDispatch();

  const userDraft = useSelector(({ account }) => account.userDraft);
  const passwordDraft = useSelector(({ account }) => account.passwordDraft);
  const currentProject = useSelector(({ project }) => project.currentProject);

  const pageContent = (index) => {
    switch (index) {
      case 0:
        return <Information error={error} submit={submit} />;

      case 1:
        return (
          <Security error={passError} passMatch={passMatch} passShort={passShort} submit={submit} />
        );

      case 2:
        return <Corporate />;

      default:
    }
  };

  const informationHandler = () => {
    if (
      userDraft.name?.length < 2 ||
      userDraft.lastName?.length > 2 ||
      !userDraft.email?.length ||
      userDraft.phone?.length < 10 ||
      userDraft.id?.length < 11 ||
      userDraft.address1?.length < 2 ||
      userDraft.city?.length < 2 ||
      userDraft.postal?.length < 4 ||
      userDraft.country?.length < 2
    ) {
      setError(true);
    } else {
      setError(false);
      dispatch(updateAccount(userDraft));
    }
  };

  const securityHandler = () => {
    if (passwordDraft.oldPassword === passwordDraft.newPassword) {
      setPassMatch(true);
    } else {
      setPassMatch(false);
    }

    if (passwordDraft.oldPassword?.length < 8 || passwordDraft.newPassword?.length < 8) {
      setPassShort(true);
      setPassError(true);
    } else {
      setPassShort(false);
    }

    if (!passMatch && !passShort) {
      dispatch(updateAccountPassword(passwordDraft));
      setSubmit(false);
      dispatch(setPasswordAccount({ ...passwordDraft, newPassword: '', oldPassword: '' }));
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setSubmit(true);

    switch (index) {
      case 0:
        return informationHandler();

      case 1:
        return securityHandler();

      default:
    }
  };

  useEffect(() => {
    async function load() {
      dispatch(fetchAccount());
    }
    if (currentProject) {
      load();
    }
  }, [dispatch, currentProject]);

  return (
    <div>
      <div className={classes.accHeader}>
        <div>
          {actions.map((content, i) => {
            return (
              <CButton
                key={i}
                onClick={() => setIndex(i)}
                style={i === index ? buttonClicked : buttonNotClicked}
              >
                {content.title}
              </CButton>
            );
          })}
        </div>
        <CButton
          disabled={false}
          htmlType="submit"
          onClick={onSubmit}
          type="primary"
          value="submit"
        >
          Save
        </CButton>
      </div>
      <Layout className={classes.layout}>{pageContent(index)}</Layout>
    </div>
  );
};

const Account = () => {
  const history = useHistory();

  const onInformation = () => {
    history.push(`/account/information`);
  };
  const onSecurity = () => {
    history.push(`/account/security`);
  };
  const onCorporate = () => {
    history.push(`/account/corporate`);
  };

  const actions = [
    { onClick: onInformation, title: 'Information', type: 'ghost' },
    { onClick: onSecurity, title: 'Security', type: 'ghost' },
    { onClick: onCorporate, title: 'Corporate', type: 'ghost' }
  ];
  return (
    <div style={mainDiv}>
      <InnerHeader title="Account" />
      <PageBody actions={actions} />
    </div>
  );
};

export default Account;
